import { Button } from '../UI';

import { FooterNavigatorProps } from './types';

export const FooterNavigator = ({
  saveButtonClassName = '',
  saveButtonVariant = 'primary',
  saveButtonName = 'Save',
  backButtonClassName = '',
  backButtonName = 'Back',
  backButton = false,
  betweenButtons,
  buttonsPosition = 'center',
  backButtonSVG,
  className = '',
  loading = false,
  isDisabledSaveButton = false,
  isDisabledCancelButton = false,
  isVisible = true,
  oneButton = false,
  cancelButtonName = 'Cancel',
  cancelButtonClassName = '',
  cancelButtonVariant = 'secondary',
  cancelButtonSVG,
  onCancel,
  onSave,
  onBack,
}: FooterNavigatorProps) => {
  return isVisible ? (
    <footer
      className={`
        ${className}
        flex
        h-20
        px-5
        items-center
        justify-${buttonsPosition}
        bg-white
        dark:bg-grey-90
      `}
    >
      {backButton && (
        <Button
          buttonClass={`${backButtonClassName} mr-5`}
          type="button"
          variant="secondary"
          onClick={onBack}
        >
          {backButtonSVG}
          {backButtonName}
        </Button>
      )}
      {oneButton ? (
        <></>
      ) : (
        <Button
          buttonClass={`${cancelButtonClassName} mr-5`}
          variant={cancelButtonVariant}
          type="button"
          onClick={onCancel}
          disabled={loading || isDisabledCancelButton}
        >
          {cancelButtonSVG}
          {cancelButtonName}
        </Button>
      )}
      {betweenButtons}
      <Button
        type="button"
        variant={saveButtonVariant}
        buttonClass={saveButtonClassName}
        onClick={onSave}
        disabled={isDisabledSaveButton}
        loading={loading}
      >
        {saveButtonName}
      </Button>
    </footer>
  ) : (
    <></>
  );
};
